var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import ReactDOM from "react-dom";
import C from "classnames";
const sizeMapper = {
    lg: "modal-lg",
    sm: "modal-sm",
};
//set to the same duration of fade transition.
const ANIMATION_DURATION = 150;
//if there there's a scroll bar, add 17px padding-right
//get an element. if it doesn't exist create it and attach it to the dom.
const getDomElement = (id, element) => {
    if (!!document.getElementById(id)) {
        return document.getElementById(id);
    }
    else {
        const tempEl = document.createElement("div");
        // tslint:disable-next-line: no-unused-expression
        tempEl && tempEl.setAttribute("id", id);
        // tslint:disable-next-line: no-unused-expression
        tempEl && element && element.appendChild(tempEl);
        return tempEl;
    }
};
export const Modal = (_a) => {
    var { backdrop = true, centered = true, fade = true, keyboard = true } = _a, props = __rest(_a, ["backdrop", "centered", "fade", "keyboard"]);
    const [show, setShow] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [openStyles, setOpenStyles] = React.useState({
        display: "block",
        paddingRight: "0px",
    });
    React.useEffect(() => {
        setOpenStyles({
            display: "block",
            paddingRight: document.body.scrollHeight > window.innerHeight ? "17px" : "0px",
        });
    }, [props.isOpen]);
    //ref to modal
    const modalRef = React.createRef();
    //get the 'modal-root' element in the DOM. This is where the modals are attached.
    const rootEl = getDomElement("modal-root", document.body);
    // close modal when clicking anywhere (if backdrop is set to true)
    // backdrop can be set to 'static', which is why we need the '=== true' here.
    React.useEffect(() => {
        backdrop === true &&
            modalRef &&
            modalRef.current &&
            window.addEventListener("click", (e) => {
                if (e.target === modalRef.current) {
                    // tslint:disable-next-line: no-unused-expression
                    props.toggle && props.toggle();
                }
            });
    }, [modalRef]);
    // use and remove keydown event listener
    React.useEffect(() => {
        //function that's called in the keydown callback.
        const escapeModal = (e) => {
            if (e.key === "Escape") {
                // tslint:disable-next-line: no-unused-expression
                props.toggle && props.toggle();
            }
        };
        if (props.isOpen) {
            // tslint:disable-next-line: no-unused-expression
            keyboard && window.addEventListener("keydown", escapeModal);
        }
        else {
            window.removeEventListener("keydown", escapeModal);
        }
        return () => window.removeEventListener("keydown", escapeModal);
    }, [props.isOpen, keyboard, props.toggle]);
    // if isOpen is true, set open (flag to render modal) to true
    React.useEffect(() => {
        if (props.isOpen) {
            setOpen(true);
            document.body.classList.add("modal-open");
            document.body.style.paddingRight = openStyles.paddingRight;
        }
        else {
            // set show to false so it starts transitioning.
            setShow(false);
            if (fade) {
                //if fade, wait for a timeout before doing things.
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        setOpen(false);
                        document.body.classList.remove("modal-open");
                        document.body.style.paddingRight = "0px";
                    }, ANIMATION_DURATION);
                });
            }
            else {
                // else do everything instantly.
                document.body.classList.remove("modal-open");
                setOpen(false);
            }
        }
    }, [props.isOpen, backdrop, fade]);
    //when open changes, if true, create backdrop element,
    //if fade, wait for next animation frame and then set show to true and add show to backdrop,
    //if not fade, do it instantly.
    React.useEffect(() => {
        if (open) {
            if (fade) {
                // seems to be a bug where requestAnimationFrame isn't quite waiting for the next frame (atleast in chrome).
                // waiting for 2 frames works.
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        // add show to the backdrop element.
                        setShow(true);
                    });
                });
            }
            else {
                //do everything instantly if fade is false(or null)
                setShow(true);
            }
        }
    }, [open, backdrop, fade]);
    return open && rootEl
        ? ReactDOM.createPortal(React.createElement(React.Fragment, null,
            React.createElement("div", { className: C("modal", fade && "fade", show && "show", props.wrapClassName && props.wrapClassName, props.vertical === "right" && "fixed-right"), tabIndex: -1, role: props.role ? props.role : "dialog", style: { display: "block" }, ref: modalRef, "aria-labelledby": props.labelledBy && props.labelledBy, "aria-hidden": "true", "data-testid": props.testId },
                React.createElement("div", { className: C("modal-dialog", centered && "modal-dialog-centered", props.size && sizeMapper[props.size], props.className && props.className, props.vertical && "modal-dialog-vertical"), role: "document", ref: props.innerRef },
                    React.createElement("div", { className: "modal-content", style: props.modalContentWidth
                            ? { width: props.modalContentWidth }
                            : {} }, React.Children.map(props.children, (child) => {
                        if (React.isValidElement(child)) {
                            return !!props.toggle
                                ? // @ts-expect-error
                                    React.cloneElement(child, { toggle: props.toggle })
                                : child;
                        }
                        return child;
                    })))),
            backdrop && (React.createElement("div", { id: "modal-backdrop", className: C("modal-backdrop", fade && "fade", show && "show") }))), rootEl)
        : null;
};
//# sourceMappingURL=Modal.js.map